import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Center, Spinner } from '@chakra-ui/react';
import PageNotFound from '../components/pageNotFound';

const Home = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    switch (window.location.host) {
      // case 'localhost:3000':
      case 'comstorpartnerportal.westconcomstor.com': {
        router.push('comstor-partner-portal/sign-in/').then();

        break;
      }
      default: {
        // eslint-disable-next-line no-console

        if (!router || !router.asPath || router.asPath === '/') {
          setLoading(false);
          break;
        }

        // Prevent infinite loop when continuously adding /#
        if (router.asPath.match(/#/)) {
          setLoading(false);
          break;
        }

        const [portal, ...rest] = router.asPath.split('/').filter((f) => !!f);
        router.push(`/${portal}/#/${rest.join('/')}`);
      }
    }
  }, [router]);

  if (loading) {
    return (
      <Center bg='transparent' h='85vh' color='text.400'>
        <Spinner thickness='4px' speed='0.65s' emptyColor='gray.200' color='gray.500' size='xl' />
      </Center>
    );
  }

  return (
    <div>
      <PageNotFound description='Looks like what you are looking for has moved' />
    </div>
  );
};

export default Home;
